module.exports = __webpack_public_path__ + "img/item2.44ea54f8.png";